var _g, _g2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTokens(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_503_6761)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D49EFF",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "url(#paint0_linear_503_6761)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_503_6761)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9999 10.75C17.715 10.75 15.6236 11.5785 14.0097 12.9514C14.0234 12.9633 14.0367 12.9757 14.0497 12.9887L16.8233 15.7623C18.6999 14.3519 21.3002 14.352 23.1767 15.7625L25.8807 13.0585C25.9181 13.0211 25.9585 12.9885 26.001 12.9607C24.3856 11.5822 22.29 10.75 19.9999 10.75ZM24.2374 16.8232C25.6479 18.6997 25.6479 21.3 24.2376 23.1766L26.9777 25.9167C27.0022 25.9412 27.0247 25.9671 27.0451 25.994C28.42 24.3795 29.2498 22.2866 29.2498 19.9999C29.2498 17.7099 28.4177 15.6143 27.0392 13.9989C27.0114 14.0415 26.9788 14.0818 26.9414 14.1192L24.2374 16.8232ZM23.177 24.2373C21.3003 25.6481 18.6998 25.6481 16.8231 24.2375L14.1087 26.9519C14.0751 26.9855 14.039 27.0153 14.0012 27.0412C15.6162 28.4184 17.711 29.2498 19.9999 29.2498C22.2868 29.2498 24.3798 28.4199 25.9943 27.0449C25.9674 27.0244 25.9416 27.0019 25.917 26.9774L23.177 24.2373ZM15.7624 23.1768C14.3518 21.3001 14.3518 18.6995 15.7626 16.8229L12.9891 14.0494C12.9761 14.0364 12.9636 14.023 12.9518 14.0093C11.5786 15.6232 10.75 17.7148 10.75 19.9999C10.75 22.2889 11.5814 24.3837 12.9587 25.9987C12.9846 25.9609 13.0144 25.9248 13.048 25.8912L15.7624 23.1768ZM9.25 19.9999C9.25 14.0629 14.0629 9.25 19.9999 9.25C25.9369 9.25 30.7498 14.0629 30.7498 19.9999C30.7498 25.9369 25.9369 30.7498 19.9999 30.7498C14.0629 30.7498 9.25 25.9369 9.25 19.9999ZM17.3161 22.6838C15.8339 21.2016 15.8339 18.7984 17.3161 17.3162C18.7983 15.834 21.2015 15.834 22.6837 17.3162C24.1659 18.7984 24.1659 21.2016 22.6837 22.6838C21.2015 24.166 18.7983 24.166 17.3161 22.6838Z",
    fill: "#C74AE3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9999 10.75C17.715 10.75 15.6236 11.5785 14.0097 12.9514C14.0234 12.9633 14.0367 12.9757 14.0497 12.9887L16.8233 15.7623C18.6999 14.3519 21.3002 14.352 23.1767 15.7625L25.8807 13.0585C25.9181 13.0211 25.9585 12.9885 26.001 12.9607C24.3856 11.5822 22.29 10.75 19.9999 10.75ZM24.2374 16.8232C25.6479 18.6997 25.6479 21.3 24.2376 23.1766L26.9777 25.9167C27.0022 25.9412 27.0247 25.9671 27.0451 25.994C28.42 24.3795 29.2498 22.2866 29.2498 19.9999C29.2498 17.7099 28.4177 15.6143 27.0392 13.9989C27.0114 14.0415 26.9788 14.0818 26.9414 14.1192L24.2374 16.8232ZM23.177 24.2373C21.3003 25.6481 18.6998 25.6481 16.8231 24.2375L14.1087 26.9519C14.0751 26.9855 14.039 27.0153 14.0012 27.0412C15.6162 28.4184 17.711 29.2498 19.9999 29.2498C22.2868 29.2498 24.3798 28.4199 25.9943 27.0449C25.9674 27.0244 25.9416 27.0019 25.917 26.9774L23.177 24.2373ZM15.7624 23.1768C14.3518 21.3001 14.3518 18.6995 15.7626 16.8229L12.9891 14.0494C12.9761 14.0364 12.9636 14.023 12.9518 14.0093C11.5786 15.6232 10.75 17.7148 10.75 19.9999C10.75 22.2889 11.5814 24.3837 12.9587 25.9987C12.9846 25.9609 13.0144 25.9248 13.048 25.8912L15.7624 23.1768ZM9.25 19.9999C9.25 14.0629 14.0629 9.25 19.9999 9.25C25.9369 9.25 30.7498 14.0629 30.7498 19.9999C30.7498 25.9369 25.9369 30.7498 19.9999 30.7498C14.0629 30.7498 9.25 25.9369 9.25 19.9999ZM17.3161 22.6838C15.8339 21.2016 15.8339 18.7984 17.3161 17.3162C18.7983 15.834 21.2015 15.834 22.6837 17.3162C24.1659 18.7984 24.1659 21.2016 22.6837 22.6838C21.2015 24.166 18.7983 24.166 17.3161 22.6838Z",
    fill: "#F7E4FB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_503_6761",
    x: -15,
    y: -15,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_503_6761"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_503_6761",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.619608 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_503_6761"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_503_6761",
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_503_6761"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_503_6761",
    x1: 8.5,
    y1: 3.5,
    x2: 24.4026,
    y2: 34.5734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D49EFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D49EFF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTokens);
export default __webpack_public_path__ + "static/media/icon-tokens.1c953a2ddf6b0c583a0ca69b4e1aa184.svg";
export { ForwardRef as ReactComponent };